import { render, staticRenderFns } from "./FormResponsavel.vue?vue&type=template&id=4dfb1cca"
import script from "./FormResponsavel.vue?vue&type=script&lang=js"
export * from "./FormResponsavel.vue?vue&type=script&lang=js"
import style0 from "./FormResponsavel.vue?vue&type=style&index=0&id=4dfb1cca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports